// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"39e134ea","1295":"ee9496b1","1313":"48d57245","1506":"358362c0","5280":"31d6cfe0","7518":"31d6cfe0","9021":"b7ce6121","9650":"3f8075e6"}[chunkId] + ".chunk.css";
};